
class CustomSort {

    sortByValue = ({ data, sorted, field, childObj, isNumber }) => {
        let sortedData = [];
        if (data && data.length) {
            let order = (sorted && sorted === "desc") ? -1 : 1;
            sortedData = data.sort((a, b) => {
                let aSort = childObj ? a[childObj][field] : a[field];
                if (aSort) aSort = isNumber ? parseInt(aSort) : (aSort.toLowerCase() ? aSort.toLowerCase() : aSort);
                let bSort = childObj ? b[childObj][field] : b[field];
                if (bSort) bSort = isNumber ? parseInt(bSort) : (bSort.toLowerCase() ? bSort.toLowerCase() : bSort);
                if (aSort && bSort && (aSort > bSort)) return 1 * order;
                if (aSort && bSort && (aSort < bSort)) return -1 * order;
                return 0;
            })
        }
        return sortedData;
    }

    sortByType = (params) => {
        const { data, sorted, orderField, orderObj } = params;
        let sortedData = [];
        let customLowest = orderObj.customLowest || 9999;
        if (data && data.length) {
            let changedData = data.map(item => {
                if (item) {
                    let orderValue = item[orderField];
                    let orderCount = 0;
                    let found = false;
                    for (let i in orderObj) {
                        if (orderValue && orderValue.includes(i)) {
                            orderCount += orderObj[i];
                            found = true;
                        }
                    }
                    if (found) return { ...item, customOrder: orderCount }
                }
                return { ...item, customOrder: customLowest }
            });

            sortedData = this.sortByValue({ data: changedData, sorted, field: "customOrder", isNumber: true });
            return sortedData.map(item => {
                if (item.customOrder) delete item.customOrder;
                return item
            })
        }
    }
}

export default CustomSort = new CustomSort();